import * as R from 'ramda'
import {
    OPEN_COMMENTS_SUCCESS,
    CLOSE_COMMENTS_SUCCESS,
    FETCH_COMMENTS_SUCCESS,
    ADD_COMMENTS_SUCCSESS
} from '../actionTypes'

const InitialState = {
    line: {},
    comments: {}
};

export default (state = InitialState, {type, payload}) => {
    switch (type) {
        case OPEN_COMMENTS_SUCCESS:
            return R.merge(state, {
                line: payload
            })
        case CLOSE_COMMENTS_SUCCESS:
            return R.merge(state, {
                line: payload
            })
        case FETCH_COMMENTS_SUCCESS:
            return R.merge(state, {
                comments: payload
            })
        /*case ADD_COMMENTS_SUCCSESS:
            const comments = {...state}
            comments.comments = {...state.comments, ...payload}
            console.log(comments)
            return comments*/
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/openComments.js